<template>
  <div class="apply">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="姓名：" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="性别：" prop="gender">
        <el-radio-group v-model="form.gender">
          <el-radio label="男"></el-radio>
          <el-radio label="女"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="申请时间：" prop="date">
        <el-date-picker type="date" placeholder="选择日期" v-model="form.date" style="width: 100%;"></el-date-picker>
      </el-form-item>
      <el-form-item label="地址：" prop="address">
        <el-input v-model="form.address"></el-input>
      </el-form-item>
      <el-form-item label="联系电话：" prop="tel">
        <el-input v-model="form.tel"></el-input>
      </el-form-item>
      <el-form-item label="邮箱/QQ：" prop="email">
        <el-input v-model="form.email"></el-input>
      </el-form-item>
      <el-form-item label="留言内容：" prop="content">
        <el-input type="textarea" rows="6" v-model="form.content"></el-input>
      </el-form-item>
    </el-form>
    <div class="btn" @click="onSubmit('form')">提交</div>
  </div>
</template>

<script>
import qs from 'qs'
export default {
  data(){
    return{
      form:{
        name:'',
        gender:'',
        date:'',
        address:'',
        tel:'',
        email:'',
        content:''
      },
      rules:{
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        gender: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        date: [
          { required: true, message: '请选择日期', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱/QQ', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入留言内容', trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params=this.form
          params=qs.stringify(params)
          this.$$axios({
            method: 'post',
            url: '/php/form.php',
            data: params
          }).then(res=>{
            this.$message({
              message: '提交成功',
              type: 'success'
            });
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
}
</script>

<style scoped>
.apply{
  padding: 30px 0;
}
.apply .btn{
  position: relative;
  border: 1px solid #5e7987;
  text-align: center;
  display: block;
  width: 180px;
  margin: 0 auto;
  max-width: 100%;
  font-size: 14px;
  font-family: 'Century751';
  padding: 20px 0;
  cursor: pointer;
  margin-top: 70px;
  transition: 1s;
}
.apply .btn:hover{
  background-color: #5e7987;
  color: #fff;
}
</style>


